<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('wdcsdd')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="toptj" v-loading="homeLoading">
                <!-- <div class="tjitem" v-if="this.user.user.roles[0].id == 11">
                    <span>最低目标</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.callNum}}</i>
                    </div>
                </div>
                <div class="tjitem" v-if="this.user.user.roles[0].id == 11">
                    <span>目前</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.recall}}</i>
                    </div>
                </div> -->
                <div class="tjitem" >
                    <span>{{$t('zczds')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.callNum}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('jrchds')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.recall}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('jrchl')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.recallRate}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('zcje')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.callMoney}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('chje')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.recallMoney}}</i>
                    </div>
                </div>
                <div class="tjitem">
                    <span>{{$t('new1')}}</span>
                    <div>
                        <i style="color: red;font-size: 20px;">{{homeTotal.recallMoneyRate}}</i>
                    </div>
                </div>
            </div>

            <div style="border: 0px solid #000;border-radius: 8px;padding:10px 0px 5px 5px;margin-bottom: 10px; width:100%;box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);">
                <el-form ref="form" :model="orderForm">
                    <el-form-item :label="$t('userName')" label-width="10%">
                        <el-input v-model="orderForm.userName" style="width:200px;" :disabled="true"></el-input>
                        <el-tooltip class="item" effect="dark" :content="$t('new2')" placement="top" style="margin-left:5px;">
                            <el-button size="small" @click="copyname(orderForm.userName)" type="primary" icon="el-icon-copy-document" circle plain></el-button>
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item :label="$t('upProductName')" label-width="15%" style="margin-left: 40%;margin-top: -60px;">
                        <el-input v-model="orderForm.upProductName" style="width:200px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('mchOrderNo')"label-width="40%" style=" margin-left: 70%;margin-top: -60px;">
                        <el-input v-model="orderForm.mchOrderNo" style="width:200px;" :disabled="true"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('dkje')" label-width="10%">
                        <el-input v-model="orderForm.outMoney" style="width:200px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('cantidad')" label-width="15%" style="margin-left: 40%;margin-top: -60px;">
                        <el-input v-model="orderForm.cantidad" style="width:200px;" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('expireTime')" label-width="40%" style="margin-left: 70%;margin-top: -60px;">
                        <el-input v-model="orderForm.expireTime" style="width:200px;" :disabled="true" ></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('exclusiveLinks')" label-width="10%">
                        <el-input v-model="orderForm.exclusiveLinks" style="width:200px;" :disabled="true"></el-input>
                        <el-tooltip class="item" effect="dark" :content="$t('new2')" placement="top" style="margin-left:5px;">
                            <el-button size="small" @click="copyname(orderForm.exclusiveLinks)" type="primary" icon="el-icon-copy-document" circle plain></el-button>
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item :label="$t('new30')" label-width="15%" style="margin-left: 40%;margin-top: -60px;">
                        <el-tooltip class="item" effect="dark" :content="$t('cd1')" placement="top">
                            <el-button size="small" @click="queryid(orderForm.userId)" type="primary" icon="el-icon-user-solid" circle plain></el-button>
                        </el-tooltip>
                    </el-form-item>
                </el-form>
                <el-form ref="form" :model="form" >
                    <el-form-item label="GPS" style="margin-left: 79.6%;margin-top: -60px;">
                        <el-input v-model="form.gpsAddress" style="width:200px;" :disabled="true"></el-input>
                        <el-tooltip class="item" effect="dark" :content="$t('new2')" placement="top" style="margin-left:5px;">
                            <el-button size="small" @click="copyname(form.gpsAddress)" type="primary" icon="el-icon-copy-document" circle plain></el-button>
                        </el-tooltip>
                    </el-form-item>
                </el-form>
            </div>

            <div class="search" style="width:47%">
                <div class="searchleft">
                    <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                        <el-form-item :label="$t('phone')">
                            <el-input v-model="searchform.phone" @keyup.enter.native="onSubmit" size="small"></el-input>
                        </el-form-item>
                        <!-- <el-form-item :label="$t('mchOrderNo')">
                            <el-input v-model="searchform.mchOrderNo" @keyup.enter.native="onSubmit" size="small" style="width:120px;"></el-input>
                        </el-form-item> -->
                        <el-form-item :label="$t('csy')" v-if="this.user.user.roles[0].id != 3 && this.user.user.roles[0].id != 14">
                            <el-select size="small" v-model="searchform.principalId" filterable style="width:160px;" :placeholder="$t('qxzcsymc')"  >
                                <el-option :label="$t('buxian')" :value="null"></el-option>
                                <el-option v-for="(item,index) in principallist1" :label="item.nickName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="onSubmit"style="width:50px; display:flex;justify-content:center;align-items:center; margin-top:2px;">
                                <p style="margin:0;">{{$t('query')}}</p>
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <div class="listbox">
                <div class="listright" v-loading="loading" style="margin-left:2px;width:47%;">
                    <el-table :data="list" highlight-current-row @current-change="handleCurrentChange" height="518"
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="isActive" :label="$t('loan6')" width="98px">
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('loan6')}}</span>
                                    <el-select
                                        v-model="searchform.isActiveSort"
                                        size="mini"
                                        clearable
                                        @change="onSubmit"
                                    >
                                        <el-option
                                            label="✅"
                                            value="2"
                                        />
                                        <el-option
                                            label="☑️"
                                            value="1"
                                        />
                                        <el-option
                                            label="❌"
                                            value="0"
                                        />
                                    </el-select>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <span v-if="scope.row.isActive === 2">✅</span>
                                <span v-if="scope.row.isActive === 1">☑️</span>
                                <span v-if="scope.row.isActive === 0 || scope.row.isActive === null">❌</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" :label="$t('status')" width="118px">
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('status')}}</span>
                                    <el-select
                                        v-model="searchform.newStatus"
                                        size="mini"
                                        clearable
                                        @change="onSubmit"
                                    >
                                        <el-option :label="$t('new3')" :value="0"></el-option>
                                        <el-option :label="$t('new11')" :value="1"></el-option>
                                        <el-option :label="$t('new12')" :value='2'></el-option>
                                        <el-option :label="$t('new14')" :value="4"></el-option>
                                        <el-option :label="$t('new15')" :value="5"></el-option>
                                        <el-option :label="$t('new16')" :value="6"></el-option>
                                        <el-option :label="$t('new17')" :value="7"></el-option>
                                    </el-select>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.newStatus==0" type="warning" :title="$t('new3')">{{$t('new3')}}</el-tag>
                                <el-tag v-if="scope.row.newStatus==1" type="primary" :title="$t('new11')">{{$t('new11')}}</el-tag>
                                <el-tag v-if="scope.row.newStatus==2" type="info" :title="$t('new12')">{{$t('new12')}}</el-tag>
                                <el-tag v-if="scope.row.newStatus==3" type="info" :title="$t('new13')">{{$t('new13')}}</el-tag>
                                <el-tag v-if="scope.row.newStatus==4" type="info" :title="$t('new14')">{{$t('new14')}}</el-tag>
                                <el-tag v-if="scope.row.newStatus==5" type="warning" :title="$t('new15')">{{$t('new15')}}</el-tag>
                                <el-tag v-if="scope.row.newStatus==6" type="success" :title="$t('new16')">{{$t('new16')}}</el-tag>
                                <el-tag v-if="scope.row.newStatus==7" type="danger" :title="$t('new17')">{{$t('new17')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="mchOrderNo" :label="$t('mchOrderNo')" width="218px">
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('mchOrderNo')}}</span>
                                    <el-input
                                        v-model="searchform.mchOrderNo"
                                        size="mini"
                                        clearable
                                        @input="debounceSearch"
                                        placeholder="搜索"
                                    />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cantidad" :label="$t('cantidad')" width="100px">
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('cantidad')}}</span>
                                    <el-select
                                        v-model="searchform.cantidadSort"
                                        size="mini"
                                        clearable
                                        @change="onSubmit"
                                    >
                                        <el-option
                                            label="升序"
                                            value="asc"
                                        />
                                        <el-option
                                            label="降序"
                                            value="desc"
                                        />
                                    </el-select>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop=" " :label="$t('type')" width="150">
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('type')}}</span>
                                    <el-select
                                        v-model="searchform.typeSort"
                                        size="mini"
                                        clearable
                                        @change="onSubmit"
                                    >
                                        <el-option
                                            :label="$t('loan4')"
                                            value="0"
                                        />
                                        <el-option
                                            :label="$t('loan5')"
                                            value="1"
                                        />
                                    </el-select>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.settleNum == 0" type="info">{{$t('loan4')}}</el-tag>
                                <el-tag v-if="scope.row.settleNum >= 1" type="info">{{$t('loan5')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="overdueDay" :label="$t('overdueDay')" width="88px"></el-table-column>
                        <el-table-column prop="agingDetail" :label="$t('fqcs')" width="88px"></el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
                <div class="listleft" style="width:53%;margin-top:-56px;">
                    <el-tabs type="border-card" v-model="activeTab" @tab-click="handleTabClick">
                        <el-tab-pane name="self" :label="$t('new27')">
                            <div class="orderdiv">
                                    <el-form ref="form" :model="orderForm" style="margin-top:25px;">
                                    <el-tooltip class="item" effect="dark" :content="$t('tjcsjl')" placement="top" style="margin-left:40px;">
                                        <el-button size="small" @click="openWrite(orderForm.phone,1,orderForm.userName)" type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                    </el-tooltip>
                                    <el-form-item :label="$t('email')" label-width="178px" style="margin-top:-35px;">
                                        <el-input v-model="orderForm.email" style="width:160px;" :disabled="true"></el-input>
                                        <el-tooltip class="item" effect="dark" :content="$t('new6')" placement="top" style="margin-left:5px;">
                                            <el-button size="small" @click="openem(orderForm.userName,orderForm.mchOrderNo,orderForm.cantidad,orderForm.expireTime,orderForm.createTime,
                                                orderForm.exclusiveLinks,orderForm.upProductName)" type="primary" icon="el-icon-message" circle plain></el-button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" :content="$t('new2')" placement="top">
                                            <el-button size="small" @click="copyname(orderForm.email)" type="primary" icon="el-icon-copy-document" circle plain></el-button>
                                        </el-tooltip>
                                    </el-form-item>
                                    <el-tooltip class="item" effect="dark" :content="$t('tjcsjl')" placement="top" style="margin-left:40px;">
                                        <el-button size="small" @click="openWrite(orderForm.phone,1, orderForm.userName)" type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                    </el-tooltip>
                                    <el-form-item :label="$t('phone')" label-width="178px" style="margin-top:-35px;">
                                        <el-input v-model="orderForm.phone" style="width:160px;" :disabled="true"></el-input>
                                        <el-tooltip class="item" effect="dark" :content="$t('new7')" placement="top" style="margin-left:5px;">
                                            <el-button size="small" @click="dial(orderForm.phone,1, orderForm.userName)" type="primary" icon="el-icon-phone" circle plain></el-button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" :content="$t('new8')" placement="top">
                                            <el-button size="small" @click="openwa(orderForm.phone, 1, orderForm.userName)" type="primary" icon="el-icon-chat-line-round" circle plain></el-button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" :content="$t('new9')" placement="top">
                                            <el-button size="small" @click="opensms(orderForm.phone, 1, orderForm.userName)" type="primary" icon="el-icon-chat-line-square" circle plain></el-button>
                                        </el-tooltip>
                                    </el-form-item>
                                </el-form>
                            </div>

                            <div class="orderdiv" style="margin-top:10px;">
                                <div class="formbox" style="width:100%; margin-top: -15px;">
                                    <template>
                                        <el-table :data="list1" height="350"
                                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                            <el-table-column :label="$t('csjl')" style="background-color:#550000">
                                                <el-table-column prop="clientName" :label="$t('userName')"></el-table-column>
                                                <el-table-column prop="tel" :label="$t('phone')"></el-table-column>
                                                <el-table-column prop="callTime" :label="$t('cjrq')">
                                                    <template slot-scope="scope">
                                                        {{scope.row.callTime|changedate}}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="concern" :label="$t('stats')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.concern==1" type="info">{{$t('new11')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==2" type="info">{{$t('new12')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==3" type="info">{{$t('new13')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==4" type="info">{{$t('new14')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==5" type="info">{{$t('new15')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==6" type="info">{{$t('new16')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==7" type="info">{{$t('new17')}}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="replyid" :label="$t('new22')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.replyid==1" type="info">{{$t('new18')}}</el-tag>
                                                        <el-tag v-if="scope.row.replyid==2" type="info">WA</el-tag>
                                                        <el-tag v-if="scope.row.replyid==3" type="info">{{$t('new19')}}</el-tag>
                                                        <el-tag v-if="scope.row.replyid==4" type="info">{{$t('new20')}}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="acceptorTime" :label="$t('rlTime')"></el-table-column>
                                                <el-table-column prop="fraude" :label="$t('new31')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.fraude==1" type="info">{{$t('new32')}}</el-tag>
                                                        <el-tag v-if="scope.row.fraude==2" type="info">{{$t('new33')}}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="userName" :label="$t('yg')"></el-table-column>
                                                <el-table-column prop="remark" :label="$t('beizhu')"></el-table-column>
                                            </el-table-column>
                                        </el-table>
                                        <div class="page">
                                            <app-page :total="total1" :current="pageNo1" :pageSize="pageSize1"
                                                @handleCurrentChange="currentchange1" @handleSizeChange="handchange1"></app-page>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </el-tab-pane>

                        <el-tab-pane name="jjlxr" :label="$t('jjlxr')">
                            <div class="orderdiv" style = "margin-top:10px;margin-bottom:10px;">
                                <el-form ref="form" :model="contactform" label-width="130px" style="margin-top:20px;">
                                    <el-tooltip class="item" effect="dark" :content="$t('tjcsjl')" placement="top" style="margin-left:5px;">
                                        <el-button size="small" @click="openWrite(contactform.onePhone,2, contactform.oneName)" type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                    </el-tooltip>
                                    <el-form-item :label="$t('lxr1xm')" style="margin-top:-36px; margin-left: -20px;">
                                        <el-input v-model="contactform.oneName" style="width:140px;" :disabled="true"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('lxr1gx')" style="margin-left: 208px;margin-top: -62px;">
                                        <el-input v-model="contactform.oneType" style="width:100px;" :disabled="true"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('lxr1dh')" style="margin-left: 380px;margin-top: -62px;">
                                        <el-input v-model="contactform.onePhone" style="width:150px;" :disabled="true"></el-input>
                                        <el-tooltip v-if="contactform.onePhone != null" class="item" effect="dark" :content="$t('new7')" placement="top" style="margin-left:5px;">
                                            <el-button size="small" @click="dial(contactform.onePhone,2, contactform.oneName)" type="primary" icon="el-icon-phone" circle plain></el-button>
                                        </el-tooltip>
                                        <el-tooltip v-if="contactform.onePhone != null" class="item" effect="dark" :content="$t('new8')" placement="top">
                                            <el-button size="small" @click="openwa(contactform.onePhone, 2, contactform.oneName)" type="primary" icon="el-icon-chat-line-round" circle plain></el-button>
                                        </el-tooltip>
                                        <el-tooltip v-if="contactform.onePhone != null" class="item" effect="dark" :content="$t('new9')" placement="top">
                                            <el-button size="small" @click="opensms(contactform.onePhone, 2, contactform.oneName)" type="primary" icon="el-icon-chat-line-square" circle plain></el-button>
                                        </el-tooltip>
                                    </el-form-item>

                                    <el-tooltip class="item" effect="dark" :content="$t('tjcsjl')" placement="top" style="margin-left:5px;">
                                        <el-button size="small" @click="openWrite(contactform.twoPhone,2, contactform.twoName)" type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                    </el-tooltip>
                                    <el-form-item :label="$t('lxr2xm')" style="margin-top:-36px; margin-left: -20px;">
                                        <el-input v-model="contactform.twoName" style="width:140px;" :disabled="true"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('lxr2gx')" style="margin-left: 208px;margin-top: -62px;">
                                        <el-input v-model="contactform.twoType" style="width:100px;" :disabled="true"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('lxr2dh')" style="margin-left: 380px;margin-top: -62px;">
                                        <el-input v-model="contactform.twoPhone" style="width:150px;" :disabled="true"></el-input>
                                        <el-tooltip v-if="contactform.twoPhone != null"  class="item" effect="dark" :content="$t('new7')" placement="top" style="margin-left:5px;">
                                            <el-button size="small" @click="dial(contactform.twoPhone,2, contactform.twoName)" type="primary" icon="el-icon-phone" circle plain></el-button>
                                        </el-tooltip>
                                        <el-tooltip v-if="contactform.twoPhone != null" class="item" effect="dark" :content="$t('new8')" placement="top">
                                            <el-button size="small" @click="openwa(contactform.twoPhone, 2, contactform.twoName)" type="primary" icon="el-icon-chat-line-round" circle plain></el-button>
                                        </el-tooltip>
                                        <el-tooltip v-if="contactform.twoPhone != null" class="item" effect="dark" :content="$t('new9')" placement="top">
                                            <el-button size="small" @click="opensms(contactform.twoPhone, 2, contactform.twoName)" type="primary" icon="el-icon-chat-line-square" circle plain></el-button>
                                        </el-tooltip>
                                    </el-form-item>


                                    <el-tooltip class="item" effect="dark" :content="$t('tjcsjl')" placement="top" style="margin-left:5px;">
                                        <el-button size="small" @click="openWrite(contactform.threePhone, 2, contactform.threePhone)" type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                    </el-tooltip>
                                    <el-form-item :label="$t('lxr3xm')" style="margin-top:-36px;margin-left: -20px;">
                                        <el-input v-model="contactform.threeName" style="width:140px;" :disabled="true"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('lxr3gx')" style="margin-left: 208px;margin-top: -62px;">
                                        <el-input v-model="contactform.threeType" style="width:100px;" :disabled="true"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('lxr3dh')" style="margin-left: 380px;margin-top: -62px;">
                                        <el-input v-model="contactform.threePhone" style="width:150px;" :disabled="true"></el-input>
                                        <el-tooltip v-if="contactform.threePhone != null" class="item" effect="dark" :content="$t('new7')" placement="top" style="margin-left:5px;">
                                            <el-button size="small" @click="dial(contactform.threePhone, 2, contactform.threePhone)" type="primary" icon="el-icon-phone" circle plain></el-button>
                                        </el-tooltip>
                                        <el-tooltip v-if="contactform.threePhone != null" class="item" effect="dark" :content="$t('new8')" placement="top">
                                            <el-button size="small" @click="openwa(contactform.threePhone, 2, contactform.threePhone)" type="primary" icon="el-icon-chat-line-round" circle plain></el-button>
                                        </el-tooltip>
                                        <el-tooltip v-if="contactform.threePhone != null" class="item" effect="dark" :content="$t('new9')" placement="top">
                                            <el-button size="small" @click="opensms(contactform.threePhone, 2, contactform.threePhone)" type="primary" icon="el-icon-chat-line-square" circle plain></el-button>
                                        </el-tooltip>
                                    </el-form-item>


                                    <el-tooltip class="item" effect="dark" :content="$t('tjcsjl')" placement="top" style="margin-left:5px;">
                                        <el-button size="small" @click="openWrite(contactform.foruPhone,2, contactform.foruName)" type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                    </el-tooltip>
                                    <el-form-item :label="$t('lxr4xm')" style="margin-top:-36px;margin-left: -20px;">
                                        <el-input v-model="contactform.foruName" style="width:140px;" :disabled="true"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('lxr4gx')" style="margin-left: 208px;margin-top: -62px;">
                                        <el-input v-model="contactform.foruType" style="width:100px;" :disabled="true"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('lxr4dh')" style="margin-left: 380px;margin-top: -62px;">
                                        <el-input v-model="contactform.foruPhone" style="width:150px;" :disabled="true"></el-input>

                                        <el-tooltip v-if="contactform.foruPhone != null" class="item" effect="dark" :content="$t('new7')" placement="top" style="margin-left:5px;">
                                            <el-button size="small" @click="dial(contactform.foruPhone,2, contactform.foruName)" type="primary" icon="el-icon-phone" circle plain></el-button>
                                        </el-tooltip>
                                        <el-tooltip v-if="contactform.foruPhone != null" class="item" effect="dark" :content="$t('new8')" placement="top">
                                            <el-button size="small" @click="openwa(contactform.foruPhone, 2, contactform.foruName)" type="primary" icon="el-icon-chat-line-round" circle plain></el-button>
                                        </el-tooltip>
                                        <el-tooltip v-if="contactform.foruPhone != null" class="item" effect="dark" :content="$t('new9')" placement="top">
                                            <el-button size="small" @click="opensms(contactform.foruPhone, 2, contactform.foruName)" type="primary" icon="el-icon-chat-line-square" circle plain></el-button>
                                        </el-tooltip>
                                    </el-form-item>
                                </el-form>
                            </div>

                            <div class="orderdiv" style="margin-top:10px;">
                                <div class="formbox" style="width:100%; margin-top: -15px;">
                                    <template>
                                        <el-table :data="list1" height="350"
                                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                            <el-table-column :label="$t('csjl')" style="background-color:#550000">
                                                <el-table-column prop="clientName" :label="$t('userName')"></el-table-column>
                                                <el-table-column prop="tel" :label="$t('phone')"></el-table-column>
                                                <el-table-column prop="callTime" :label="$t('cjrq')">
                                                    <template slot-scope="scope">
                                                        {{scope.row.callTime|changedate}}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="concern" :label="$t('stats')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.concern==1" type="info">{{$t('new11')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==2" type="info">{{$t('new12')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==3" type="info">{{$t('new13')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==4" type="info">{{$t('new14')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==5" type="info">{{$t('new15')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==6" type="info">{{$t('new16')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==7" type="info">{{$t('new17')}}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="replyid" :label="$t('new22')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.replyid==1" type="info">{{$t('new18')}}</el-tag>
                                                        <el-tag v-if="scope.row.replyid==2" type="info">WA</el-tag>
                                                        <el-tag v-if="scope.row.replyid==3" type="info">{{$t('new19')}}</el-tag>
                                                        <el-tag v-if="scope.row.replyid==4" type="info">{{$t('new20')}}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="acceptorTime" :label="$t('rlTime')"></el-table-column>
                                                <el-table-column prop="fraude" :label="$t('new31')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.fraude==1" type="info">{{$t('new32')}}</el-tag>
                                                        <el-tag v-if="scope.row.fraude==2" type="info">{{$t('new33')}}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="userName" :label="$t('yg')"></el-table-column>
                                                <el-table-column prop="remark" :label="$t('beizhu')"></el-table-column>
                                            </el-table-column>
                                        </el-table>
                                        <div class="page">
                                            <app-page :total="total1" :current="pageNo1" :pageSize="pageSize1"
                                                @handleCurrentChange="currentchange1" @handleSizeChange="handchange1"></app-page>
                                        </div>
                                    </template>
                                </div>
                            </div>  
                        </el-tab-pane>
                        
                        <el-tab-pane name="txl" :label="$t('txl')">
                            <div class="search">
                                <el-form :inline="true" :model="searchform1" class="demo-form-inline" @submit.native.prevent >
                                    <el-form-item :label="$t('new21')">
                                        <el-input v-model="searchform1.phone" style="width: 150px;" @keyup.enter.native="txlonSubmit" size="small"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button size="small" type="primary" @click="txlonSubmit">{{$t('query')}}</el-button>
                                    </el-form-item>
                                    <el-button type="success" v-if="this.cardFirst != null" @click="cf">Qaa1：{{cardFirst}}</el-button>
                                    <el-button type="success" v-if="this.cardSecond != null" @click="cs">Qaa2：{{cardSecond}}</el-button>
                                </el-form>
                            </div>
                            <div class="orderdiv">
                                <div class="formbox" style="width:100%;margin-top: -15px;" v-loading="txlloading">
                                    <template>
                                        <el-table :data="ctList" height="300"
                                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                                <el-table-column prop="phone" label="add" width="60">
                                                    <template slot-scope="scope">
                                                        <el-button size="small" @click="openWrite(scope.row.phone,3, scope.row.name)" type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="phone" :label="$t('phone')"></el-table-column>
                                                <el-table-column prop="name" :label="$t('name')"></el-table-column>
                                                <el-table-column prop="callNumber" :label="$t('thcs')"></el-table-column>
                                                <el-table-column prop="callTime" :label="$t('thsj')"></el-table-column>
                                                <el-table-column prop="jobName" :label="$t('operator')" width="150" fixed="right">
                                                    <template slot-scope="scope">
                                                        <el-tooltip class="item" effect="dark" :content="$t('new7')" placement="top">
                                                            <el-button size="small" @click="dial(scope.row.phone,3, scope.row.name)" type="primary" icon="el-icon-phone" circle plain></el-button>
                                                        </el-tooltip>
                                                        <el-tooltip class="item" effect="dark" :content="$t('new8')" placement="top">
                                                            <el-button size="small" @click="openwa(scope.row.phone, 3, scope.row.name)" type="primary" icon="el-icon-chat-line-round" circle plain></el-button>
                                                        </el-tooltip>
                                                        <el-tooltip class="item" effect="dark" :content="$t('new9')" placement="top">
                                                            <el-button size="small" @click="opensms(scope.row.phone, 3, scope.row.name)" type="primary" icon="el-icon-chat-line-square" circle plain></el-button>
                                                        </el-tooltip>
                                                    </template>
                                                </el-table-column>
                                            </el-table-column>
                                        </el-table>
                                        <div class="page">
                                            <app-page :total="ctTotal" :current="ctPageNo" :pageSize="ctPageSize"
                                                @handleCurrentChange="ctCurrentchange" @handleSizeChange="ctHandchange"></app-page>
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <div class="orderdiv" style="margin-top:10px;">
                                <div class="formbox" style="width:100%; margin-top: -15px;">
                                    <template>
                                        <el-table :data="list1" height="350"
                                            :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                                            <el-table-column :label="$t('csjl')" style="background-color:#550000">
                                                <el-table-column prop="clientName" :label="$t('userName')"></el-table-column>
                                                <el-table-column prop="tel" :label="$t('phone')"></el-table-column>
                                                <el-table-column prop="callTime" :label="$t('cjrq')">
                                                    <template slot-scope="scope">
                                                        {{scope.row.callTime|changedate}}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="concern" :label="$t('stats')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.concern==1" type="info">{{$t('new11')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==2" type="info">{{$t('new12')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==3" type="info">{{$t('new13')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==4" type="info">{{$t('new14')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==5" type="info">{{$t('new15')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==6" type="info">{{$t('new16')}}</el-tag>
                                                        <el-tag v-if="scope.row.concern==7" type="info">{{$t('new17')}}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="replyid" :label="$t('new22')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.replyid==1" type="info">{{$t('new18')}}</el-tag>
                                                        <el-tag v-if="scope.row.replyid==2" type="info">WA</el-tag>
                                                        <el-tag v-if="scope.row.replyid==3" type="info">{{$t('new19')}}</el-tag>
                                                        <el-tag v-if="scope.row.replyid==4" type="info">{{$t('new20')}}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="acceptorTime" :label="$t('rlTime')"></el-table-column>
                                                <el-table-column prop="fraude" :label="$t('new31')">
                                                    <template slot-scope="scope">
                                                        <el-tag v-if="scope.row.fraude==1" type="info">{{$t('new32')}}</el-tag>
                                                        <el-tag v-if="scope.row.fraude==2" type="info">{{$t('new33')}}</el-tag>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="userName" :label="$t('yg')"></el-table-column>
                                                <el-table-column prop="remark" :label="$t('beizhu')"></el-table-column>
                                            </el-table-column>
                                        </el-table>
                                        <div class="page">
                                            <app-page :total="total1" :current="pageNo1" :pageSize="pageSize1"
                                                @handleCurrentChange="currentchange1" @handleSizeChange="handchange1"></app-page>
                                        </div>
                                    </template>
                                </div>
                            </div>  
                        </el-tab-pane>
                        
                    </el-tabs>
                </div>
            </div>
        </div>
        <pop-up :title="$t('tjcsjl')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box" class="addCss">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small" label-width="120px">
                    <el-form-item :label="$t('userName')" prop="clientName">
                        <el-input v-model="form.clientName" style="width: 200px;"/>
                    </el-form-item>
                    <el-form-item :label="$t('phone')" prop="tel">
                        <el-input v-model.number="form.tel" />
                    </el-form-item>
                    <el-form-item :label="$t('stats')" prop="concern">
                        <el-select size="small" v-model="form.concern" style="width:200px;" :placeholder="$t('new23')">
                            <el-option :label="$t('new11')" :value="1"></el-option>
                            <el-option :label="$t('new12')" :value='2'></el-option>
                            <!-- <el-option :label="$t('new13')" :value="3"></el-option> -->
                            <el-option :label="$t('new14')" :value="4"></el-option>
                            <el-option :label="$t('new15')" :value="5"></el-option>
                            <el-option :label="$t('new16')" :value="6"></el-option>
                            <el-option :label="$t('new17')" :value="7"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('new22')" prop="replyid">
                        <el-select size="small" v-model="form.replyid" style="width:200px;" :placeholder="$t('new24')">
                            <el-option :label="$t('new18')" :value="1"></el-option>
                            <el-option label="WA" :value='2'></el-option>
                            <el-option :label="$t('new19')" :value="3"></el-option>
                            <el-option :label="$t('new20')" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('new25')" prop="followType">
                        <el-select size="small" v-model="form.followType" :disabled="form.flag === 1" style="width:200px;" :placeholder="$t('new26')">
                            <el-option :label="$t('new27')" :value="1"></el-option>
                            <el-option :label="$t('jjlxr')" :value='2'></el-option>
                            <el-option :label="$t('txl')" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('rlTime')" prop="acceptorTime">
                        <el-col :span="11">
                            <el-date-picker type="date" :placeholder="$t('xzTime')" v-model="form.acceptorTime" style="width: 190%;">
                            </el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item :label="$t('new31')" prop="fraude">
                        <template>
                            <el-radio v-model="form.fraude" :label="1">{{$t('new32')}}</el-radio>
                            <el-radio v-model="form.fraude" :label="2">{{$t('new33')}}</el-radio>
                        </template>
                    </el-form-item>
                    <el-form-item :label="$t('beizhu')" prop="remark">
                        <el-input type="textarea" v-model="form.remark" style="width: 107%;"/>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    mchOrderNo: null,
                    email: null,
                    userName: null,
                    cantidad: null,
                    days: null,
                    overdueDay: null,
                    expireTime: null,
                    createTime: null,
                    exclusiveLinks:null,
                    stats: null,
                    birthday: null,
                    addressAll: null,
                    gender: null,
                    fatherLastName: null,
                    motherLastName: null,
                    postalCode: null,
                    fullName: null,
                    idNumber: null,
                    district: null,
                    email: null,
                    educationName: null,
                    employmentName: null,
                    comoanyName: null,
                    comoanyPhone: null,
                    workingYearName: null,
                    monthlySalaryName: null,
                    workingDaysName: null,
                    idCardPositive: null,
                    idCardReverse: null,
                    faceUrl: null,
                    phoneBrand: null,
                    phoneDevice: null,
                    gpsAddress: null,
                    faceBook: null,
                    whatsApp: null,
                },
                rules: {
                    clientName:[{ required: true, message: this.$t('qsrxm'), trigger: 'blur' },],
                    tel:[{ required: true, message: this.$t('qsrdh'), trigger: 'blur' },],
                    concern:[{ required: true, message: this.$t('qxzyggx'), trigger: 'blur' },],
                    //acceptorTime:[{ required: true, message: this.$t('qxzrq'), trigger: 'blur' },],
                    classId:[{ required: true, message: this.$t('qxzflmc'), trigger: 'blur' },],
                    replyid:[{ required: true, message: this.$t('new24'), trigger: 'blur' },],
                    followType:[{ required: true, message: this.$t('new26'), trigger: 'blur' },],
                },
                orderForm:{
                    phone: null,
                    mchOrderNo: null,
                    email: null,
                    userName: null,
                    cantidad: null,
                    days: null,
                    overdueDay: null,
                    expireTime: null,
                    createTime: null,
                    exclusiveLinks:null,
                    upProductName:null,
                    userId:null,
                    stats: null
                },
                contactform:{
                    onePhone:null,
                    oneName:null,
                    oneType:null,
                    twoPhone:null,
                    twoName:null,
                    twoType:null,
                    threePhone:null,
                    threeName:null,
                    threeType:null,
                    foruPhone:null,
                    foruName:null,
                    foruType:null,
                },
                homeTotal:{
                    callNum: 0,
                    recall: 0,
                    recallRate: 0,
                    callMoney: 0,
                    recallMoney: 0,
                    recallMoneyRate:0
                },
                searchform: {
                    blurry: "",
                },
                searchform1: {
                    phone: "",
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                loading: false,
                txlloading: false,
                loanLoading:false,
                homeLoading:false,
                showadd: false,
                list: [],
                value1:[],
                searchform:{},
                searchform1:{},
                total: 0,
                pageNo: 1,
                pageSize: 10,
                loanTotal: 0,
                loanPageNo: 1,
                loanPageSize: 5,
                ctTotal: 0,
                ctPageNo: 1,
                ctPageSize: 5,
                total1: 0,
                pageNo1: 1,
                pageSize1: 10,
                total2: 0,
                pageNo2: 1,
                pageSize2: 10,
                smsTotal: 0,
                smsPageNo: 1,
                smsPageSize: 5,
                repTotal: 0,
                repPageNo: 1,
                repPageSize: 10,
                keyword: '',
                user:null,
                rolelist: [],
                status: null,
                classlist: [],
                loanList:[],
                ctList:[],
                list1: [],
                list2: [],
                list3: [],
                smsList:[],
                repList:[],
                currentRow: null,
                orderDeId:null,
                relePhone:null,
                principallist1:[],
                accountlist: [],
                cardFirst: null,
                cardSecond: null,
                orderNoD:null,
                oid:null,
                activeTab: 'self',
                tabletype:null,
                imgList: [],
            }
        },
        mounted() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            const name = this.user.user.username

            var date = new Date();
            var UTCTime = Date.now() + date.getTimezoneOffset() * 60 * 1000;
            const timeArr = UTCTime - 6 * 60 * 60 * 1000;
            const timeStr = this.formatTime(timeArr)
            this.addWatermark(`${name} ${timeStr}`)
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
            this.getclass()
            this.getHomeTotal()
            this.getprincipal1()
            this.getaccount()
        },
        methods: {
            addWatermark(text) {
                const canvas = document.createElement('canvas')
                canvas.width = 300
                canvas.height = 200
                const ctx = canvas.getContext('2d')
                ctx.rotate(-20 * Math.PI / 180)
                ctx.font = '16px Arial'
                ctx.fillStyle = 'rgba(0,0,0,0.08)'
                ctx.fillText(text, 20, 100)
                const base64 = canvas.toDataURL()
                const div = document.createElement('div')
                div.style.position = 'fixed'
                div.style.top = '0'
                div.style.left = '0'
                div.style.width = '100%'
                div.style.height = '100%'
                div.style.pointerEvents = 'none'
                div.style.backgroundImage = `url(${base64})`
                div.style.zIndex = '9999'
                document.body.appendChild(div)
            },
            formatTime(timestamp) {
                const d = new Date(timestamp)
                const pad = (n) => n.toString().padStart(2, '0')

                return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
                    + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
            },
            // 防抖搜索
            debounceSearch() {
                clearTimeout(this.searchTimer)
                this.searchTimer = setTimeout(() => {
                    this.onSubmit()
                }, 500)
            },
            dial(row, row1, row2) {
                _api.get(apiurl.dial, {
                    phone : row,
                    type : row1,
                    nation : localStorage.getItem("nation"),
                }).then(res => {
                    alert(res.message);
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
                //this.openWrite(row, row1, 1, row2);
            },
            copyname(row) {
                navigator.clipboard.writeText(row).then(() => {
                    this.$message.success(this.$t('new28'));
                }).catch(() => {
                    this.$message.error(this.$t('new29'));
                });
            },
            // row 电话
            // row1 跟踪类型
            // row2 姓名
            openwa(row, row1, row2) {
                window.open('https://wa.me/' + row, '_blank')
                //this.openWrite(row, row1, 2, row2);
            },
            opensms(row, row1, row2) {
                navigator.clipboard.writeText(row);
                window.open('https://messages.google.com/web', '_blank')
                //this.openWrite(row, row1, 3, row2);
            },
            // row3 邮箱
            openem(row, row1, row2, row3, row4, row5, row6) {
                //this.openWrite(row, row1, 4, row2);
                const userName = row;
                const appName = row6;
                const orderNo = row1;
                const dueDate = row3;
                const repayLink = row5;
                const amount = row2;

                const timestamp = row4;
                const date = new Date(timestamp);
                const y = date.getFullYear();
                const m = String(date.getMonth() + 1).padStart(2, '0');
                const d = String(date.getDate()).padStart(2, '0');
                const loanDate = `${y}-${m}-${d}`;

                const content = [
                    `Estimado: ${userName}.`,
                    ``,
                    `Somos la plataforma proveedora de servicios de prést@mo <${appName}>,`,
                    `su pedido ${orderNo} en nuestra plataforma el ${loanDate}.`,
                    ``,
                    `Los detalles de los pedidos que están a punto de expirar son los siguientes:`,
                    ``,
                    `Número de orden: ${orderNo}`,
                    `Fecha del prést@mo: ${loanDate}`,
                    `Fecha de vencimiento: ${dueDate}`,
                    `Importe adeudado: ${amount}`,
                    `La lista de: ${repayLink}`,
                    ``,
                    `El reembolso anticipado aumentará tu crédito en nuestra plataforma,`,
                    `por favor devuelva el prestamo lo antes posible a traves de nuestra APP.`,
                    `Puede volver a pedir prestado tras la liquidación。`,
                    ``,
                    `¡¡¡LOS PAGOS ATRASDOS ANADIRAN INTERESES EXTRA,`,
                    `ASI QUE POR FAVOR PAQUE A TIEMPO!!!`,
                    ``,
                    `<${appName}> le desea un buen día.`,
                    ``,
                    `¡¡¡Los prést@mos hacen la vida mejor!!!`,
                    `El equipo <${appName}>`
                ].join('\n');

                this.$confirm(
                    `<pre style="white-space:pre-wrap;font-size:13px;line-height:1.6">${content}</pre>`,this.$t('new34'),
                    {
                        confirmButtonText: this.$t('new2'),
                        cancelButtonText: this.$t('qux'),
                        type: 'warning',
                        dangerouslyUseHTMLString: true
                    }
                ).then(() => {
                    navigator.clipboard.writeText(content).then(() => {
                        this.$message.success(this.$t('new28'));
                    });
                }).catch(() => {
                    // 关闭不需要提示也可以留空
                });
            },
            queryid(row) {
                _api.get(apiurl.userInfo, {
                    userId: row
                }).then(res => {
                    this.imgList = []
                    this.openIdCard();
                    this.imgList = [
                        res.data.idCardPositive,
                        res.data.faceUrl
                    ]
                })
            },
            openIdCard() {
                const loadImage = (src) => {
                    return new Promise((resolve) => {
                        const img = new Image()
                        img.src = src
                        img.onload = () => resolve()
                        img.onerror = () => resolve()
                    })
                }

                Promise.all(this.imgList.map(src => loadImage(src))).then(() => {
                    this.$msgbox({
                    title: this.$t('new30'),
                    message: this.$createElement(
                        'div',
                        {
                            style: 'display:flex;gap:16px;justify-content:center'
                        },
                        this.imgList.map(img =>
                            this.$createElement('el-image', {
                                style: 'width:160px',
                                attrs: {
                                src: img,
                                'preview-src-list': this.imgList
                                }
                            })
                        )
                    ),
                        confirmButtonText: this.$t('login3')
                    })
                })
            },
            querylink(row) {
                this.$alert(row, '还款链接', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$message({
                        type: 'info',
                        message: `action: ${ action }`
                        });
                    }
                });
            },

            // row 电话
            // row1 跟踪类型  1：本人  2：紧急联系人  3：通讯录
            // row2 回复类型  1：电话  2：WA  3：短信 4：邮件
            // row3 姓名
            openWrite(row, row1, row2, row3) {
                this.showadd = true
                this.orderDeId = this.oid;
                this.form = {
                    tel: row,
                    followType: row1,
                    clientName: row2,
                    orderId:this.oid,
                    fraude: 2,
                    nation: localStorage.getItem("nation"),
                    // 不可修改
                    flag:1,
                }
            },
            openadd(row) {
                this.orderDeId = row.id;
                this.showadd = true
                this.form = {
                    id: null,
                    clientName: null,
                    tel: null,
                    callTime: null,
                    concern: null,
                    acceptorTime: null,
                    className: null,
                    remark: null,
                    fraude: 2,
                    userName: null,
                    replyid: null,
                    followType: null,
                    nation: localStorage.getItem("nation"),
                    orderId: row.id
                }
            },
            getaccount() {
                _api.get(apiurl.accountBook, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.accountlist = res.data
                })
            },
            handleCurrentChange(val) {
                this.currentRow = val.userId;
                this.orderDeId = val.id;
                this.relePhone = val.phone;
                this.oid = val.id;
                this.getDetail();
                this.getOrderDetail();
                this.getCtList();
                //this.getList1();
                this.getContactDetail();
            },
            getprincipal1() {
                _api.get(apiurl.users, {
                    roleId: 3,
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.principallist1 = res.content
                })
            },
            getclass() {
                _api.get(apiurl.classifyAll, {
                }).then(res => {
                    this.classlist = res.data
                })
            },
            getconfirm() {
                if (this.form.clientName == null || this.form.clientName=="") {
                    this.$message.error(this.$t('qsrxm'))
                    return
                }
                if (this.form.tel == null || this.form.tel=="") {
                    this.$message.error(this.$t('qsrdh'))
                    return
                }
                if (this.form.concern == null || this.form.concern=="") {
                    this.$message.error(this.$t('qxzyggx'))
                    return
                }

                if (this.form.replyid == null || this.form.replyid=="") {
                    this.$message.error("请选择回复方式")
                    return
                }

                if (this.form.followType == null || this.form.followType=="") {
                    this.$message.error("请选择跟进类型")
                    return
                }
                
                // if (this.form.acceptorTime == null || this.form.acceptorTime=="") {
                //     this.$message.error(this.$t('qxzrq'))
                //     return
                // }
                if (this.form.orderId == null || this.form.orderId=="") {
                    this.$message.error(this.$t('qxzdd'))
                    return
                }
                _api.post(apiurl.callInfo, this.form)
                .then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('addSuccess')
                    })
                    this.getList()
                    this.showadd = false
                    this.form = {
                        id: null,
                        clientName: null,
                        tel: null,
                        callTime: null,
                        concern: null,
                        replyid: null,
                        followType: null,
                        acceptorTime: null,
                        fraude: null,
                        className: null,
                        remark: null,
                        userName: null,
                        orderId: this.orderDeId
                    }
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            cf() {
                this.dial(this.cardFirst,1,"")
            },
            cs() {
                this.dial(this.cardSecond,1,"")
            },
            getList() {
                this.loading = true
                _api.get(apiurl.mycallorder, {
                    page: this.pageNo,
                    size: this.pageSize,
                    mchOrderNo: this.searchform.mchOrderNo,
                    nation:localStorage.getItem("nation"),
                    newCall: 1,
                    isActiveSort: this.searchform.isActiveSort,
                    cantidadSort: this.searchform.cantidadSort,
                    typeSort: this.searchform.typeSort,
                    newStatus: this.searchform.newStatus,
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            getCtList() {
                this.txlloading = true
                _api.get(apiurl.userContact, {
                    page: this.ctPageNo,
                    size: this.ctPageSize,
                    nation:localStorage.getItem("nation"),
                    blurry:this.searchform1.phone,
                    userId: this.currentRow
                }).then(res => {
                    this.ctList = res.data.data
                    this.ctTotal = res.data.totalCount
                    this.txlloading = false
                })
                this.getList1(3)
            },
            getLoanList() {
                this.loanLoading = true
                _api.get(apiurl.myOrderRecord, {
                    page: this.loanPageNo,
                    size: this.loanPageSize,
                    nation:localStorage.getItem("nation"),
                    userId: this.currentRow
                }).then(res => {
                    this.loanLoading = false
                    this.loanList = res.data.list
                    this.loanTotal = res.data.total
                })
            },
            getOrderDetail(){
                _api.get(apiurl.orderDetail,{
                    nation:localStorage.getItem("nation"),
                    orderId:this.orderDeId
                }).then(res=>{
                    this.orderForm.phone=res.data.phone
                    this.orderForm.mchOrderNo=res.data.mchOrderNo
                    this.orderForm.email=res.data.email
                    this.orderForm.userName=res.data.userName
                    this.orderForm.cantidad=res.data.cantidad
                    this.orderForm.days=res.data.days
                    this.orderForm.overdueDay=res.data.overdueDay
                    this.orderForm.expireTime=res.data.expireTime
                    this.orderForm.createTime=res.data.createTime
                    this.orderForm.exclusiveLinks=res.data.exclusiveLinks
                    this.orderForm.stats=res.data.stats
                    this.orderForm.outMoney=res.data.outMoney
                    this.orderForm.upProductName=res.data.upProductName
                    this.orderForm.userId=res.data.userId
                    this.cardFirst=res.data.cardFirst
                    this.cardSecond=res.data.cardSecond
                    this.orderNoD = res.data.mchOrderNo
                })
            },
            getContactDetail(){
                _api.get(apiurl.contactInfo,{
                    userId:this.currentRow
                }).then(res=>{
                    this.contactform.onePhone=res.data.onePhone
                    this.contactform.oneName=res.data.oneName
                    this.contactform.oneType=res.data.oneType
                    this.contactform.twoPhone=res.data.twoPhone
                    this.contactform.twoName=res.data.twoName
                    this.contactform.twoType=res.data.twoType

                    this.contactform.threePhone=res.data.threePhone
                    this.contactform.threeName=res.data.threeName
                    this.contactform.threeType=res.data.threeType
                    this.contactform.foruPhone=res.data.foruPhone
                    this.contactform.foruName=res.data.foruName
                    this.contactform.foruType=res.data.foruType
                })
                this.getList1(2)
            },
            
            getDetail(){
                _api.get(apiurl.userInfo,{userId:this.currentRow}).then(res=>{
                    this.form.birthday=res.data.birthday
                    this.form.addressAll=res.data.addressAll
                    this.form.gender=res.data.gender
                    this.form.fatherLastName=res.data.fatherLastName
                    this.form.motherLastName=res.data.motherLastName
                    this.form.postalCode=res.data.postalCode
                    this.form.fullName=res.data.fullName
                    this.form.idNumber=res.data.idNumber
                    this.form.district=res.data.district
                    this.form.email=res.data.email
                    this.form.educationName=res.data.educationName
                    this.form.employmentName=res.data.employmentName
                    this.form.comoanyName=res.data.comoanyName
                    this.form.comoanyPhone=res.data.comoanyPhone
                    this.form.workingYearName=res.data.workingYearName
                    this.form.monthlySalaryName=res.data.monthlySalaryName
                    this.form.workingDaysName=res.data.workingDaysName
                    this.form.idCardPositive=res.data.idCardPositive
                    this.form.idCardReverse=res.data.idCardReverse
                    this.form.faceUrl=res.data.faceUrl
                    this.form.phoneBrand=res.data.phoneBrand
                    this.form.phoneDevice=res.data.phoneDevice
                    this.form.gpsAddress=res.data.gpsAddress
                    this.form.faceBook=res.data.faceBook
                    this.form.whatsApp=res.data.whatsApp
                })
                this.getList1(1);
            },
            getHomeTotal(){
                this.homeLoading = true
                _api.get(apiurl.callTotal,{
                    nation:localStorage.getItem("nation"),
                }).then(res=>{
                    this.homeLoading = false
                    this.homeTotal.callNum=res.data.callNum
                    this.homeTotal.recall=res.data.recall
                    this.homeTotal.recallRate=res.data.recallRate
                    this.homeTotal.callMoney=res.data.callMoney
                    this.homeTotal.recallMoney=res.data.recallMoney
                    this.homeTotal.recallMoneyRate=res.data.recallMoneyRate
                })
            },
            handleTabClick(tab) {
                this.pageNo1 = 1
                if (tab.name === 'jjlxr') {
                    this.tabletype = 2
                    this.getList1(2)
                } else if (tab.name === 'txl') {
                    this.tabletype = 3
                    this.getList1(3)
                } else {
                    this.tabletype = 1
                    this.getList1(1)
                }
            },
            getList1(val) {
                _api.get(apiurl.callInfo, {
                    page: this.pageNo1,
                    size: this.pageSize1,
                    orderId: this.orderDeId,
                    followType: val,
                }).then(res => {
                    this.list1 = res.data.list
                    this.total1 = res.data.total
                })
            },
            getList2() {
                _api.get(apiurl.relevanceOrder, {
                    page: this.pageNo2,
                    size: this.pageSize2,
                    phone: this.relePhone,
                    orderId: this.orderDeId
                }).then(res => {
                    this.list2 = res.data.data
                    this.total2 = res.data.totalCount
                })
            },
            getList3() {
                _api.get(apiurl.associatedTel, {
                    orderId: this.orderDeId
                }).then(res => {
                    this.list3 = res.data
                })
            },
            getSmsList(){
                _api.get(apiurl.sysNews, {
                    page: this.smsPageNo,
                    size: this.smsPageSize,
                    userId:this.currentRow
                }).then(res => {
                    this.smsList = res.data.list
                    this.smsTotal = res.data.total
                })
            },
            getRepList(){
                _api.get(apiurl.repayment, {
                    page: this.repPageNo,
                    size: this.repPageSize,
                    userId:this.currentRow
                }).then(res => {
                    this.repList = res.data.list
                    this.repTotal = res.data.total
                })
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            txlonSubmit() {
                this.ctPageNo = 1
                this.getCtList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
            loanHandchange(data) { //分页Size变化
                this.loanPageSize = data
                this.loanPageNo = 1
                this.getLoanList()
            },
            loanCurrentchange(data) { //当前页变化
                this.loanPageNo = data
                this.getLoanList()
            },
            ctHandchange(data) { //分页Size变化
                this.ctPageSize = data
                this.ctPageNo = 1
                this.getCtList()
            },
            ctCurrentchange(data) { //当前页变化
                this.ctPageNo = data
                this.getCtList()
            },
            handchange1(data) { //分页Size变化
                this.pageSize1 = data
                this.pageNo1 = 1
                this.getList1(this.tabletype)
            },
            currentchange1(data) { //当前页变化
                this.pageNo1 = data
                this.getList1(this.tabletype)
            },
            handchange2(data) { //分页Size变化
                this.pageSize2 = data
                this.pageNo2 = 1
                this.getList2()
            },
            currentchange2(data) { //当前页变化
                this.pageNo2 = data
                this.getList2()
            },
            smsHandchange(data) { //分页Size变化
                this.smsPageSize = data
                this.smsPageNo = 1
                this.getSmsList()
            },
            smsCurrentchange(data) { //当前页变化
                this.smsPageNo = data
                this.getSmsList()
            },
            repHandchange(data) { //分页Size变化
                this.repPageSize = data
                this.repPageNo = 1
                this.getRepList()
            },
            repCurrentchange(data) { //当前页变化
                this.repPageNo = data
                this.getRepList()
            },
        }
    }
</script>
<style scoped>
    
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .orderdiv{
        display: flex;
        border-style: ridge;
        border-bottom: 1px solid #EBEEF5;
    }

    .listleft {
        width: 50%;
        margin-left: 0.5%;
    }

    body .el-table th.gutter{
        display: table-cell!important;
    }

    .listright {
        width: 50%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }
    .formbox{ padding:15px 0; margin-top: 10px;}

    .listrighttop span {
        float: right;
    }
    .toptj{ 
        display: flex; 
        margin-bottom: 10px;
        border: 1px solid white;
        border-radius: 6px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    }
    .tjitem{ 
        flex: 1; 
        background: #ffffff; 
        cursor: pointer; 
        border: #ebedf0 solid 1px; 
        height: 60px; 
        margin-right: 10px;
        padding: 8px 12px;
        text-align: center;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }

    .icon {
        width: 1em;
        height: 1em;
        fill: #25D366;
    }

    .table-filter {
        display: flex;
        flex-direction: column;
        padding: 4px;
    }

    .table-filter span {
        margin-bottom: 4px;
        font-size: 13px;
    }
    
</style>